import { SAMOLET_YM_COUNTER } from '../constants/common';
export var isJsonString = function (str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
export var declOfNum = function (number, words) {
    return words[number % 100 > 4 && number % 100 < 20
        ? 2
        : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]];
};
export var checkIsYMCounterInitiated = function () {
    var _a;
    try {
        return (typeof Ya !== 'undefined' &&
            ((_a = Ya._metrika) === null || _a === void 0 ? void 0 : _a.getCounters().some(function (_a) {
                var id = _a.id;
                return id === SAMOLET_YM_COUNTER;
            })));
    }
    catch (e) {
        return false;
    }
};
export var ymReachGoal = function (target) {
    try {
        checkIsYMCounterInitiated() && ym(SAMOLET_YM_COUNTER, 'reachGoal', target);
    }
    catch (e) {
        console.error("[ymReachGoal] - " + SAMOLET_YM_COUNTER + " - " + target);
    }
};
//# sourceMappingURL=common.js.map